import { useForm, SubmitHandler, Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Text, InputText, Button } from '@pentabd/ui';
import SiteMaintenance from '@components/SiteMaintenance';
import { useAuth } from '@hooks/useAuth';

interface Props {
  handleDownload: () => void;
}

const Form = ({ handleDownload }: Props) => {
  const { t } = useTranslation();
  const { requested, signIn } = useAuth();

  const {
    handleSubmit,
    formState: { errors },
    control,
  } = useForm<FormData>();

  const onSubmit: SubmitHandler<any> = (data) => {
    localStorage.setItem('creds', JSON.stringify(data));
    signIn(data.userName, data.password);
  };

  return (
    <>
      {/* 2 */}
      <div className="d-flex flex-column justify-content-center flex-1">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="login-form d-flex mx-auto justify-content-center flex-column gap-9 align-items-center">
            {/* logo */}
            <img
              src="/company-logo.png"
              alt="company-logo"
              width={156}
              height={170}
            />

            {/* LOGIN_TITLE */}
            <div className="d-flex flex-column gap-6 align-items-center">
              <Text size="sm" weight="semibold" color="dark" sizeType="display">
                {t(`LOGIN.COMPANY_NAME`)}
              </Text>
            </div>

            {process.env.REACT_APP_MAINTENANCE_TEXT !== 'true' && (
              <>
                {/* user id */}
                <div className="w-100">
                  <Controller
                    control={control}
                    name={`userName` as any}
                    render={({ field: { onChange } }) => (
                      <InputText
                        name={`userName`}
                        subtitle={t(`LOGIN.USER_ID`)}
                        onChange={onChange}
                        error={errors as any}
                        controlling
                      />
                    )}
                  />
                </div>

                {/* password */}
                <div className="w-100">
                  <Controller
                    control={control}
                    name={`password` as any}
                    render={({ field: { onChange } }) => (
                      <InputText
                        name={`password`}
                        subtitle={t(`LOGIN.PASSWORD`)}
                        type="password"
                        error={errors as any}
                        onChange={onChange}
                        controlling
                      />
                    )}
                  />
                </div>

                {/* submit btn */}
                <Button
                  fill="fill"
                  className="w-100"
                  type="primary"
                  htmlType="submit"
                  loading={requested}
                >
                  {t(`LOGIN.LOGIN_BUTTON`)}
                </Button>

                {/* 3 - password */}
                {/* <div className="py-9">
                  <Text size="sm" weight="normal" color="subtitle1">
                  {t('LOGIN.PASSWORD_FORGOT')} 
                    Password Grant Flow
                  </Text>
                </div>  */}
              </>
            )}

            {/* maintenance */}
            {process.env.REACT_APP_MAINTENANCE_TEXT === 'true' && (
              <SiteMaintenance />
            )}
          </div>
        </form>
      </div>
    </>
  );
};
export default Form;
